import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExposureMinus2Icon(props: IconProps) {
    return <Icon {...props} iconKey={"exposure_minus_2"}/>
}
